import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProviderStatementEmailTemplate.List.IRequest;
type Response = Api.Core.ProviderStatementEmailTemplate.List.IResponse;
type Headers = Api.Core.ProviderStatementEmailTemplate.List.IHeaders;
const url = '/api/Management/ProviderStatementEmailTemplate';
export default async function providerStatementEmailTemplateListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
